import { request } from "@api/auth/otp/request/path";

export const otp = {
  request,
};
